import moment from "moment";

// RN format: YY-6020-NNNNN. Suggestions never guess from any other format.
const rnParts = (workOrderNumber?: string): { year: string; sequence: string } | null => {
  const match = String(workOrderNumber || "").match(/^(\d{2})-6020-(\d{5})$/);
  return match ? { year: match[1], sequence: match[2] } : null;
};

/** Finished-product lot: the final five RN digits followed by the RN year. */
export const suggestFinishedBatch = (workOrderNumber?: string): string => {
  const parts = rnParts(workOrderNumber);
  return parts ? `${parts.sequence}${parts.year}` : "";
};

/** GP lot shown for an RN outside the RN screen (plan, calendar): the lot saved on the RN, else the suggestion. */
export const workOrderFinishedBatch = (workOrder?: { number?: string; serialNumber?: string } | null): string =>
  workOrder ? workOrder.serialNumber || suggestFinishedBatch(workOrder.number) : "";

/** Intermediate / semi-product lot: its ident plus the RN sequence and year. */
export const suggestInterProductBatch = (ident?: string, workOrderNumber?: string): string => {
  const parts = rnParts(workOrderNumber);
  return ident && parts ? `${ident}-${parts.sequence}-${parts.year}` : "";
};

/** Finished-product expiry is production date + shelf life, minus one month. */
export const suggestFinishedExpiry = (productionDate?: string | null, deadlineMonths?: number | null): string => {
  const months = Number(deadlineMonths);
  if (!productionDate || !Number.isFinite(months) || months <= 0) return "";
  const date = moment(productionDate);
  return date.isValid() ? date.add(months - 1, "months").format("DD.MM.YYYY") : "";
};

/** Intermediate / semi-product expiry is production date + one month. */
export const suggestInterProductExpiry = (productionDate?: string | null): string => {
  if (!productionDate) return "";
  const date = moment(productionDate);
  return date.isValid() ? date.add(1, "months").format("DD.MM.YYYY") : "";
};
